<h2>{{action}} for {{inst.name}}</h2>

<div *ngIf="order" class="date_row">
    <span class="label">Created:</span>
    <span class="timestamp">{{displayCreated()}}</span>
</div>

<form [formGroup]="form"
      (ngSubmit)="submit()">

    <div class="column">
        <mat-form-field class="promo_field">
            <mat-label>Promo Code</mat-label>
            <input matInput
                   required
                   formControlName="promoCode"
                   (input)="codeChanged()">
            <mat-hint>Create code by adding characters to the prefix</mat-hint>
            <mat-error>{{fields.promoCode.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field id="unit_count_field"
                        class="number_field">
            <mat-label>Number of Test Kits</mat-label>
            <input matInput
                   required
                   type="number"
                   formControlName="unitCount">
            <mat-error>{{fields.unitCount.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field class="number_field">
            <mat-label>Unit Price</mat-label>
            <span matPrefix>$&nbsp;</span>
            <input matInput
                   required
                   type="number"
                   formControlName="unitPrice">
            <mat-error>{{fields.unitPrice.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field class="number_field">
            <mat-label>Discount</mat-label>
            <span matPrefix>$&nbsp;</span>
            <input matInput
                   type="number"
                   formControlName="discount">
            <mat-error>{{fields.discount.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Discount description</mat-label>
            <textarea matInput formControlName="discountDesc"></textarea>
        </mat-form-field>

        <mat-form-field class="number_field">
            <mat-label>Additional Charges</mat-label>
            <span matPrefix>$&nbsp;</span>
            <input matInput
                   type="number"
                   formControlName="charges">
            <mat-error>{{fields.charges.errors}}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Charges' description</mat-label>
            <textarea matInput formControlName="chargesDesc"></textarea>
        </mat-form-field>

        <div class="total_row">
            <span class="label">Total:</span>
            <span class="money">{{total | currency}}</span>
        </div>
    </div>

    <div class="column">
        <mat-checkbox id="expires_check"
                      [checked]="promoExpires"
                      (change)="expiresChanged($event)">Expires</mat-checkbox>

        <div class="expires_row" [ngClass]="{hidden: !promoExpires}">
            <mat-form-field id="date_field">
                <mat-label>On</mat-label>
                <input matInput
                       [matDatepicker]="picker"
                       [min]="tomorrow"
                       formControlName="promoExpDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
                <mat-label>At</mat-label>
                <input matInput
                       [ngClass]="{clickable: promoExpires}"
                       [ngxTimepicker]="timePicker"
                       readonly
                       formControlName="promoExpTime">
                <span matSuffix id="clock_toggle"><mat-icon [ngClass]="{gray: !promoExpires}">access_time</mat-icon></span>
                <ngx-material-timepicker #timePicker></ngx-material-timepicker>
            </mat-form-field>
        </div>
        <div class="time_hint" [ngClass]="{hidden: !promoExpires}">
            In your local time zone {{timeZone}}
        </div>

        <mat-form-field id="notes_field">
            <mat-label>Notes</mat-label>
            <textarea matInput
                      id="notes_area"
                      formControlName="notes"></textarea>
        </mat-form-field>

        <div class="paid_row">
            <mat-checkbox formControlName="paid">Paid</mat-checkbox>
        </div>

        <mat-form-field>
            <mat-label>Payment information</mat-label>
            <textarea matInput
                      id="payment_info_area"
                      formControlName="paymentInfo"></textarea>
        </mat-form-field>
        <div class="button_row">
            <button mat-raised-button
                    color="primary"
                    [disabled]="!canSave()"
                    type="submit">Save</button>
            <button mat-raised-button
                    [disabled]="submitting"
                    type="button"
                    (click)="cancel()">Cancel</button>
        </div>
        <div>
            <mat-spinner *ngIf="submitting" [diameter]="30"></mat-spinner>
        </div>
    </div>
    
</form>
